import React from "react";

import { Divider, Row, Table, Typography } from "antd";
import { FONT } from "constants/index";
const { Text } = Typography;

const ExempleCycle = (props) => {
  return (
    <>
      <Row justify="center">
        <Text style={{ fontSize: "25px", fontFamily: FONT, marginTop: "10px" }}>
          {props.title}
        </Text>
      </Row>
      <Divider />
      <Table
        columns={props.columns}
        dataSource={props.data}
        pagination={false}
        size="small"
        scroll={{ x: "max-content" }}
        locale={{
          emptyText: "Sem registro",
        }}
      />
    </>
  );
};
export default ExempleCycle;
